import clsx from 'clsx';
import Enllac from 'components/corporatiu/Enllac';

import Image from 'next/image';
import { dataResources } from 'utils/constants';
import MenuLogin from '../MenuLogin';

import styles from './mainmenu.module.scss';
import { useViewport } from 'hooks/corporatiu/useViewport';
import __isEmpty from 'lodash/isEmpty';

const imageLoader = ({ src }) => {
    return `${src}`;
};

const MenuCorporate = (props) => {
    const { requiredServices, seccio } = props;
    const { basePath } = dataResources;
    const { isMobile } = useViewport();

    const TRESCATINFOW = '/_resources/logos/3catinfo_W.svg?v=JIT_ENV_RESOURCES_VERSION';

    const logoinfoClass = clsx(styles.logoinfo, {
        [styles.noBefore]: isMobile === undefined, // Si no está inicializado, desactiva el estilo :before
        [styles.actiu]: seccio === '3catinfo'
    });

    const stylesCorporate = clsx({
        [styles.corporate]: true
    });

    return (
        <nav aria-label='Menú corporatiu' className={stylesCorporate} id='navegacio'>
            <div className={styles.wrapper}>
                <div className={styles.logo} id='navLogo'>
                    <Enllac href='/3cat/'>
                        <div className={styles.logo3cat}>
                            <Image
                                loader={imageLoader}
                                loading='eager'
                                unoptimized={true}
                                width={111}
                                height={32}
                                alt='Logo 3Cat'
                                src={basePath + '/_resources/logos/3cat_color.svg?v=JIT_ENV_RESOURCES_VERSION'}
                            />
                        </div>
                    </Enllac>
                </div>
                <ul className={styles.marques} id='navMarques'>
                    <li>
                        <Enllac
                            href='https://www.3cat.cat/tv3/'
                            className={clsx(styles.logoLink, styles.logoRebaixat, styles.tv3, {
                                [styles.actiu]: seccio === 'tv3'
                            })}
                        >
                            <div className={styles.logotv3}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={32}
                                    height={24}
                                    alt='TV3'
                                    src={basePath + '/_resources/logos/tv3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac
                            href='https://www.3cat.cat/catradio/'
                            className={clsx(styles.logoLink, styles.logoRebaixat, styles.cr, {
                                [styles.actiu]: seccio === 'catradio'
                            })}
                        >
                            <div className={styles.logocr}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={32}
                                    height={24}
                                    alt='Catalunya Ràdio'
                                    src={basePath + '/_resources/logos/cr_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='/3catinfo/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={logoinfoClass}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={129}
                                    height={26}
                                    alt='3catinfo'
                                    src={basePath + TRESCATINFOW}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='https://www.3cat.cat/tv3/sx3/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={styles.logosx3}>
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={40.74}
                                    height={20}
                                    alt='SX3'
                                    src={basePath + '/_resources/logos/sx3_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </div>
                        </Enllac>
                    </li>
                    <li>
                        <Enllac href='/3cat/eva/' className={`${styles.logoLink} ${styles.logoRebaixat}`}>
                            <div className={styles.logoeva}>
                                <Image
                                    src={basePath + '/_resources/logos/eva_W.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={40.87}
                                    height={18}
                                    alt='EVA'
                                ></Image>
                            </div>
                        </Enllac>
                    </li>
                </ul>

                <ul className={styles.secundari}>
                    <li>
                        <div className={clsx(styles.corpo, { [styles.actiu]: seccio === 'corporatiu' })} id='navCorpo'>
                            <Enllac href='/corporatiu/ca/el-grup/' className={styles.logoRebaixat}>
                                Corporatiu
                            </Enllac>
                        </div>
                    </li>
                    <li>
                        <div className={styles.icones} id='navIcones'>
                            <Enllac
                                href='https://botiga.3cat.cat/'
                                title='accedeix a la botiga de 3Cat'
                                className={`${styles.iconesLink} ${styles.logoRebaixat}`}
                            >
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={22}
                                    height={22}
                                    alt='botiga'
                                    src={basePath + '/_resources/icones/noticies/blanc/ic_botiga.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </Enllac>
                            <Enllac
                                href='/cercador/?profile=portalunic'
                                title='accedeix a la pàgina de cerca'
                                className={`${styles.iconesLink} ${styles.logoRebaixat}`}
                            >
                                <Image
                                    loader={imageLoader}
                                    loading='eager'
                                    unoptimized={true}
                                    width={24}
                                    height={24}
                                    alt='cercador'
                                    src={basePath + '/_resources/icones/noticies/blanc/cercador.svg?v=JIT_ENV_RESOURCES_VERSION'}
                                />
                            </Enllac>
                        </div>
                    </li>
                    <li>
                        <div className={`${styles.iconesLink} ${styles.iconesUser} ${styles.logoRebaixat}`}>
                            <MenuLogin requiredServices={requiredServices} className={styles.login} />
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

const MainMenu = ({ requiredServices, isSideMenuOpen, setIsSideMenuOpen, seccio }) => {
    return (
        <>
            <MenuCorporate
                requiredServices={requiredServices}
                isSideMenuOpen={isSideMenuOpen}
                seccio={seccio}
                setIsSideMenuOpen={setIsSideMenuOpen}
            />
        </>
    );
};

export default MainMenu;
